import { CookieConfig } from '@fenderdigital/custom-hooks/lib/LocalAndCookieStorage';

const cookieConfig: CookieConfig = {
  cookieSession: `${process.env.REACT_APP_CLIENT_FC_COOKIE_SESSION}`,
  cookieDomain: `${process.env.REACT_APP_CLIENT_FC_COOKIE_DOMAIN}`,
};

export default cookieConfig;
